import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { uploadMedia } from '../actions/mediaActions';
import { useEffect, useState } from 'react';
import Loader from '../components/Loader';
import Message from '../components/Message';
import { Button, Form } from 'react-bootstrap';
import FormContainer from '../components/FormContainer';
import { Link } from 'react-router-dom';
import { ANNOUNCEMENT_FILE_UPLOAD_RESET } from '../constants/announcementConstants';
import {listTags} from "../actions/tagActions";
import {TAG_LIST_RESET} from "../constants/tagConstants";
import {logout} from "../actions/userActions";
import ThreeColumnRow from "../components/ThreeColumnRow";
import {listCampaigns} from "../actions/campaignActions";
import {MultiSelect} from "../components/MultiSelect";
import CreatableSelect from "react-select/creatable";

const AnnouncementRegisterScreen = ({ history, language, t }) => {
    const dispatch = useDispatch();

    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;
    const announcement = useSelector((state) => state.announcementCreate);
    const { loading, message, error } = announcement;
    const [myFile, setMyFile] = useState(null);
    const [fileName, setFileName] = useState();
    const [announcementName, setAnnouncementName] = useState('');
    const [announcementNameError,setAnnouncementNameError] = useState('');
    const [description, setDescription] = useState('');
    const [tags, setTags] = useState([]);
    const [suggestions, setSuggestions] = useState([]);

    const tagList = useSelector(state => state.tagList);
    const {loading: tagsLoading, error: tagsError, tags: userTags, success: userTagSuccess} = tagList;

    const [campaignOptions, setCampaignOptions] = useState([]);
    const [selectedCampaigns, setSelectedCampaigns] = useState([]);
    const campaignsList = useSelector((state) => state.campaignList);
    const {loading: campaignsLoading, campaignList, error: campaignsError, success: campaignListSuccess} = campaignsList;

    useEffect(() => {
        if (!userInfo) {
            history.push('/login');
        }
    }, [userInfo, history]);

    useEffect(()=>{
        if(error && error.includes('Not authorized')){
            dispatch(logout());
            history.push('/login');
        }
    },[error]);

    useEffect(() => {
        if (!userTagSuccess) {
            dispatch(listTags());
        } else {
            setSuggestions(() =>
                userTags.map((tgs) => {
                    tgs.label = tgs.name;
                    tgs.value = tgs._id;
                    return tgs;
                })
            );
        }
    }, [userTagSuccess, dispatch]);



    useEffect(() => {
        if (message) {
            dispatch({ type: ANNOUNCEMENT_FILE_UPLOAD_RESET });
            history.push('/announcements');
        }
    }, [dispatch, message, history]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if(announcementNameError !== ''){
            return;
        }
        const formData = new FormData();
        console.log(myFile);
        formData.append('announcementName', announcementName);
        formData.append('description', description);
        formData.append('tags', JSON.stringify(tags));
        formData.append('file', myFile);

        if(selectedCampaigns) {
            const properCampaigns = selectedCampaigns.map(element => {
                let {label, value, ...rest} = element;
                return rest;
            });

            formData.append('campaigns', JSON.stringify(properCampaigns));
        }

        dispatch(uploadMedia('announcements', formData));
        dispatch({type: TAG_LIST_RESET});
    };

    const onFileChange = (event) => {
        console.log(event.target.files);
        if (event.target.files.length > 0) {
            setMyFile(event.target.files[0]);
            setFileName(event.target.files[0].name);
        }
    };

    useEffect(()=>{
        if(!campaignListSuccess){
            dispatch(listCampaigns());
        }
        if(campaignList){
            //console.log(campaignList);
            const moddedList = campaignList.map(element => {
                element.label = element.name;
                element.value = element._id;
                return element;
            });
            //console.log(campaignList);
            setCampaignOptions(moddedList);
        }
    },[dispatch, campaignList, campaignListSuccess]);

    const onSelectedCampaignsChange = (campaignsFromSelect) => {
        setSelectedCampaigns(campaignsFromSelect);
    }

    return (
        <>
            <ThreeColumnRow firstColumn={<Link to='/announcements' className='btn btn-info m-0 p-2'>
                {t('button_back')}
            </Link>} secondColumn={t('announcement_new_announcement')}/>

            <FormContainer>
                <Form onSubmit={handleSubmit} autoComplete='off'>
                    <Form.Group controlId='announcementName'>
                        <Form.Label>{t('announcement_name')}</Form.Label>
                        <Form.Control
                            type='text'
                            placeholder={t('announcement_name')}
                            required
                            value={announcementName}
                            onChange={(event) => {
                                if(event.target.value.includes(',')){
                                    setAnnouncementNameError(t('announcement_name_error'));
                                }
                                else {
                                    setAnnouncementNameError('');
                                }
                                setAnnouncementName(event.target.value);
                            }}
                            isInvalid={announcementName.includes(',')}
                        />
                        <Form.Control.Feedback type='invalid'>{announcementNameError}</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId='announcementFile'>
                        <Form.Label>{t('announcement_file')}</Form.Label>
                        <Form.File
                            label={fileName ?? t('file_select_description')}
                            accept='.mp3,.wav'
                            data-browse={t('button_select')}
                            required
                            onChange={onFileChange}
                            custom
                        />
                    </Form.Group>

                    <Form.Group controlId='announcementDescription'>
                        <Form.Label>{t('announcement_description')}</Form.Label>
                        <Form.Control
                            type='text'
                            placeholder={t('announcement_description')}
                            required
                            value={description}
                            onChange={(event) => {
                                setDescription(event.target.value);
                            }}
                        />
                    </Form.Group>

                    <Form.Group controlId='announcementCampaigns'>
                        <Form.Label>{t('announcement_campaigns')}</Form.Label>
                        <MultiSelect
                            options={campaignOptions}
                            value={selectedCampaigns}
                            onChange={onSelectedCampaignsChange}
                            placeholder={t('announcement_campaigns_description')}
                        />
                    </Form.Group>

                    {tagsLoading ? (
                        <Loader/>
                    ) : (
                        <Form.Group controlId='tags'>
                            <Form.Label>{t('announcement_tags')}</Form.Label>
                            <CreatableSelect
                                isMulti
                                isSearchable
                                isClearable
                                formatCreateLabel= {(inputValue) => `${t('create_tag')}: "${inputValue}"`}
                                onChange={(newTag) => {
                                    const temporaryTag = suggestions.find(tag => tag.name === newTag.name);

                                    if(temporaryTag !== null && temporaryTag !== undefined){
                                        newTag = temporaryTag;
                                    }
                                    //console.log(newTag);
                                    setTags(newTag);
                                }}
                                onCreateOption={(newTag) => {
                                    const temporaryTag = suggestions.find(tag => tag.name === newTag.name);

                                    if(temporaryTag !== null && temporaryTag !== undefined){
                                        newTag = temporaryTag;
                                    }
                                    else {
                                        newTag = {
                                            id: undefined,
                                            label: newTag,
                                            value: newTag,
                                            name: newTag
                                        }
                                    }
                                    //console.log(newTag);
                                    setTags([...tags, newTag]);
                                }}
                                options={suggestions}
                                value={tags}
                                placeholder={t('announcement_tags_description')}
                                className='react-select-container'
                                classNamePrefix='react-select'
                            />
                            {/*<ReactTags
                                allowNew={true}
                                placeholderText={t('announcement_tags_description')}
                                allowBackspace={false}
                                onDelete={(idx) => {
                                    const newTags = tags.slice(0);
                                    newTags.splice(idx, 1);
                                    setTags(newTags);
                                }}
                                onAddition={(newTag) => {
                                    setTags([...tags, newTag]);
                                }}
                                suggestions={suggestions}
                                tags={tags}
                            />*/}
                        </Form.Group>)}

                    <div style={{ marginTop: '2rem', marginBottom: '2rem' }}>
                        {error ? (
                            <Message variant='danger'>{error}</Message>
                        ) : null}
                    </div>

                    {loading ? (
                        <Loader />
                    ) : (
                        <Button
                            type='submit'
                            variant='success'
                            className='d-block mx-auto mt-4'
                        >
                            {t('button_save')}
                        </Button>
                    )}
                </Form>
            </FormContainer>
        </>
    );
};

export default AnnouncementRegisterScreen;
